module.exports = __webpack_public_path__ + "img/2_4.8a596398.png";